export default __webpack_public_path__ + "static/sprite-c4220aa6a4f798edd24ca5e17c3cc4db.svg";